import React, { useCallback } from 'react';
import cx from 'classnames';
import { Input } from 'reactstrap';

import styles from './RubricWeights.module.scss';

function RubricQuestionWeightRow({
  questionSet,
  question,
  className,
  isStandardView,
  draftWeight,
  standardWeight,
  committedWeight,
  onChange,
}) {
  const q = question;
  const questionGuid = q.guid;

  const handleOnChange = useCallback(
    (ev) => onChange(questionGuid, ev.target.value),
    [onChange, questionGuid]
  );

  const hasOverride =
    draftWeight !== undefined &&
    draftWeight !== null &&
    String(draftWeight) !== '';
  const isChanged = String(draftWeight ?? '') !== String(committedWeight ?? '');

  return (
    <div
      className={cx(
        styles['question-weight-row'],
        styles['weight-row'],
        className
      )}
    >
      <div className={styles['weight-row-name']}>{q.text}</div>
      <div className={styles['weight-row-value']}>
        <Input
          className={cx(styles['weight-input'], {
            [styles['weight-input--changed']]: isChanged,
            [styles['weight-input--overridden']]:
              !isStandardView && !isChanged && hasOverride,
          })}
          placeholder={isStandardView ? undefined : standardWeight}
          value={draftWeight}
          onChange={handleOnChange}
        />
      </div>
    </div>
  );
}

export default RubricQuestionWeightRow;
